// extracted by mini-css-extract-plugin
export default {"container":"PO-z","title":"QO-z","link":"RO-z"};